import { useState, FormEvent } from 'react';
import { Button, Input } from '../ui';
import { useAuth } from '../../stores/auth.store';

interface ForgotPasswordFormProps {
  onSuccess?: (email: string) => void;
  onBack?: () => void;
}

export function ForgotPasswordForm({
  onSuccess,
  onBack,
}: ForgotPasswordFormProps) {
  const { resetPassword, isLoading, error, clearError } = useAuth();
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    clearError();

    const success = await resetPassword(email);
    if (success) {
      onSuccess?.(email);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="text-center mb-6">
        <p className="text-slate-300">
          Enter your email address and we&apos;ll send you a code to reset your
          password.
        </p>
      </div>

      <Input
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        required
        fullWidth
        disabled={isLoading}
      />

      {error && (
        <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/20">
          <p className="text-sm text-red-400">{error}</p>
        </div>
      )}

      <Button type="submit" fullWidth isLoading={isLoading}>
        Send Reset Code
      </Button>

      <button
        type="button"
        onClick={onBack}
        className="w-full text-center text-sm text-slate-400 hover:text-white transition-colors"
      >
        ← Back to sign in
      </button>
    </form>
  );
}
